export const NOTIFICATIONS_ENDPOINTS = {
  RECENT_NEWS: (userId: string) => `/notifications/${userId}/recent-news`,
};
